import { getAdjustedTime } from '@/lib/timeUtils'

export function formatScheduledTime(
	utcString: string,
	locale?: string,
	todayLabel = 'Today',
	timeZoneOffset?: number,
	tomorrowLabel = 'Tomorrow',
	atSeparator = 'at',
): string {
	const raw = new Date(utcString)
	if (isNaN(raw.getTime())) return utcString

	const date = timeZoneOffset !== undefined ? getAdjustedTime(timeZoneOffset, raw) : raw
	const now = timeZoneOffset !== undefined ? getAdjustedTime(timeZoneOffset) : new Date()

	const isSameCalendarDay = (a: Date, b: Date) =>
		a.getFullYear() === b.getFullYear() &&
		a.getMonth() === b.getMonth() &&
		a.getDate() === b.getDate()

	const tomorrow = new Date(now)
	tomorrow.setDate(tomorrow.getDate() + 1)

	const timeStr = date.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' })
	const dateStr = date.toLocaleDateString(locale, {
		weekday: 'long',
		month: 'numeric',
		day: 'numeric',
	})

	if (isSameCalendarDay(date, now)) return `${todayLabel} ${atSeparator} ${timeStr}`
	if (isSameCalendarDay(date, tomorrow)) return `${tomorrowLabel} ${atSeparator} ${timeStr}`
	return `${dateStr} ${atSeparator} ${timeStr}`
}
